import $ from 'jquery';
// import 'ev-emitter';
// import 'imagesloaded';
import 'slick-carousel';
import imagesLoaded from 'imagesloaded';

/**
 * Accolades module
 *
 * @module Accolades
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-01 using @14four/generator-excalibur 0.1.23
 * converted to ES6 on 2023-09-25 using ChatGPT 
 */
class Accolades {
  constructor(element) {
    this.$el = $(element);
    this.setupSlick();
    this.setupBinds();
  }

  setupBinds() {
    imagesLoaded(this.$el, () => {
      setTimeout(() => {
        this.checkTextSizes();
        this.$el.find('.slide').removeClass('inactive');
      }, 400);
    });

    $(window).on('resize', () => this.checkTextSizes());
  }

  checkTextSizes() {
    const $slides = this.$el.find('.slide');
    $slides.each((index, slide) => {
      const $slide = $(slide);
      const $contentText = $slide.find('.content-text');
      $contentText.css('font-size', '');
      let fontSize = parseInt($contentText.css('font-size'), 10);
      const $slideHeight = $slide.find('.content').outerHeight();
      let $textHeight = $contentText.outerHeight();
      while ($textHeight > $slideHeight) {
        $contentText.css('font-size', --fontSize);
        $textHeight = $contentText.outerHeight();
      }
    });
  }

  setupSlick() {
    this.$el.find('.accoladesCarousel').slick({
      // autoplay: true,
      arrows: true,
      dots: true,
      infinite: true,
      speed: 1500,
      autoplaySpeed: 2000,
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: true,
      swipe: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  }

}

export default Accolades;
